export interface TranslationFields extends Record<string, string> {
  name_fr: string
  name_en: string
}

export enum LanguageCode {
  EN = 'en',
  FR = 'fr',
}

export type TranslatedFields = Partial<Record<LanguageCode, string | null>>
